import Gobalstore from "../index";
export const actions = {
  getFeeTypeLevel1: function (localStore) {
    this.axios({
      method: "GET",
      url: "/business/guarded/feeTypeLevel1",
    }).then(function (response) {
      localStore.commit("setFeeTypeLevel1", response.data);
    });
  },
  getFeeTypeByParent: function (localStore, payload) {
    this.axios({
      method: "GET",
      url: `/business/guarded/feeTypeByParent/${payload.parent}`,
    }).then(function (response) {
      localStore.commit("setFeeTypeLevel"+payload.ATLevel, response.data);
    });
  },
};
